var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._g({staticClass:"app-button-continue",class:{'invert' : _vm.invertStyle},attrs:{"tabindex":"0"},on:{"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter"))return null;return _vm.$emit('click')}}},_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }